import { ICategory } from '../../interfaces';
import { useSelect } from "@refinedev/antd";

export const useDictionarySelectProps = () => {
    const { selectProps: applicationStatusProps } = useSelect<ICategory>({
        resource: 'dictionary/application-statuses',
        optionLabel: 'name',
        optionValue: 'id',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: "server"
        }
    });

    const { selectProps: applicationTypeProps } = useSelect<ICategory>({
        resource: 'dictionary/application-types',
        optionLabel: 'name',
        optionValue: 'id',

        onSearch: value => [
            {
                field: 'query',
                operator: 'contains',
                value,
            },
        ],

        meta: {},

        pagination: {
            mode: "server"
        }
    });

    return {
        applicationStatusProps,
        applicationTypeProps,
    };
};
